import { CopyButton } from 'components/CopyButton';

type CopyableCommandProps = {
  label: string;
  command: string;
  copyLabel: string;
  testId?: string;
  onCopy?: () => void;
};

/** A labelled, bordered block showing a copyable command or value. */
export const CopyableCommand = ({
  label,
  command,
  copyLabel,
  testId,
  onCopy,
}: CopyableCommandProps) => (
  <div className="flex flex-col gap-1.5" data-testid={testId}>
    <span className="text-xs text-text-general-neutral-mid">{label}</span>
    <div className="flex items-start gap-2 p-2.5 rounded-md border border-border-bg-neutral bg-fill-interactive-neutral-idle">
      <pre className="grow overflow-x-auto text-xs whitespace-pre-wrap break-all text-text-general-neutral-strong">
        {command}
      </pre>
      <CopyButton
        value={command}
        title={copyLabel}
        className="shrink-0"
        onCopy={onCopy}
      />
    </div>
  </div>
);
